module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, _vm._l((_vm.pages), function(page, i) {
    return _c('Page', {
      key: i,
      staticClass: "ProjectInfo"
    }, [(i === 0) ? _c('div', {}, [_c('img', {
      staticClass: "Logo",
      class: {
        'Logo--right': _vm.logoPosition === 'right'
      },
      attrs: {
        "src": _vm.logoSrc
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ClientAddress"
    }, [_c('span', {
      staticClass: "CompanyAddress"
    }, [_vm._v(_vm._s(_vm.company && _vm.company.Name) + " " + _vm._s(_vm.company && _vm.company.Type) + " • " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.Street) + " " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.House) + " • " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.PLZ) + " " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.City))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Client-Name']))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Contact-Person']))]), _vm._v(" "), _vm._l((_vm.lines(_vm.projectInfo['Street'])), function(line, i) {
      return _c('span', {
        key: i
      }, [_vm._v(_vm._s(line))])
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Place']))])], 2), _vm._v(" "), _c('div', {
      staticClass: "ProposalInfo"
    }, [_c('span', {
      staticClass: "ProposalInfo-Number"
    }, [_vm._v(_vm._s(_vm.projectInfo['Type']) + " Nr. " + _vm._s(_vm.projectInfo['Project-Number']))]), _vm._v(" "), _c('span', {
      staticClass: "ProposalInfo-Date"
    }, [_vm._v("vom " + _vm._s(_vm.projectInfo['Date']))])])]) : _vm._e(), _vm._v(" "), _c('article', {
      domProps: {
        "innerHTML": _vm._s(page.content)
      }
    }), _vm._v(" "), (i === 0) ? _c('CompanyAddress', {
      attrs: {
        "company": _vm.company
      }
    }) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36749d4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/CoverPage.vue
// module id = 162
// module chunks = 4